import React, { useContext, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './CreateProjectType.module.css';
import { postData } from '~/helper/apiService';
import { ToastContext } from '../Context/ToastProvider';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import ProjectTypeForm from '../Form/ProjectTypeForm';

const cx = classNames.bind(styles);

function CreateProjectType() {
  const fileInputRef = useRef(null);
  const [key, setKey] = useState('');
  const { addToast } = useContext(ToastContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const res = await postData('/projects/createType', formData);
    if (res.status === 'success') {
      setKey((prev) => prev + 1);
      setModalComponentContent(null);
    } 
    addToast(res);
  };

  return (
    <div className={cx('wrapper')}>
      <ProjectTypeForm
        keyForm={key}
        titleBtn="Create Project Type"
        handleSubmit={handleSubmit}
        fileInputRef={fileInputRef}
      />
    </div>
  );
}

export default CreateProjectType;